/**
 * 確認ダイアログ
 *
 * @param {string} message - 確認メッセージ
 * @param {string} ok - OKボタンのラベル
 * @param {string} cancel - キャンセルボタンのラベル
 * @returns {Promise<boolean>} OKならtrue、キャンセルならfalse
 */
window.showConfirm = function (message, ok = '', cancel = '') {
    return new Promise((resolve) => {
        const modalEl = document.getElementById('globalConfirmModal');
        if (!modalEl) {
            resolve(false);
            return;
        }

        document.getElementById('globalConfirmMessage').textContent = message;
        if (ok) document.getElementById('globalConfirmOk').textContent = ok;
        if (cancel) document.getElementById('globalConfirmCancel').textContent = cancel;

        const modal = bootstrap.Modal.getOrCreateInstance(modalEl);

        function cleanup() {
            modalEl.removeEventListener('hidden.bs.modal', onHidden);
            document.getElementById('globalConfirmOk').removeEventListener('click', onOk);
        }

        function onOk() {
            cleanup();
            modal.hide();
            resolve(true);
        }

        function onHidden() {
            cleanup();
            resolve(false);
        }

        document.getElementById('globalConfirmOk').addEventListener('click', onOk);
        modalEl.addEventListener('hidden.bs.modal', onHidden);

        modal.show();
    });
};
